<template>

    <div class="sales_ratio-wrap p-20px bg-white" >
        <div class="title_wrap">
            <div class="title mb-15px">{{$t('dashBoard.cSysWeeklySale.weeklySales')}} </div>

        </div>
        <div class="hike_n_drop_wrap">
            <div class="d-flex">
                <div>
                    <div class="wrap">
                        <div class="top"><span class="text-muted">{{$t('dashBoard.cSysWeeklySale.thisWeek')}} </span></div>
                        <div v-if="chartValues.thisWeekSum" class="bottom">
                            <h3 class="text-info d-flex">{{chartValues.currency+' '}}{{chartValues.thisWeekSum | formatNumber(chartValues.currency)}} 
                                <!-- <span
                                    class="d-flex pl-5px pb-3px">

                                    <img v-if="chartValues && chartValues.percentOfThisWeek>=0"
                                    src="@imgPath/img/svg/icons/green-up-arrow.svg" alt=""
                                    class="sm-icon-dash">
                                    <img v-if="chartValues && chartValues.percentOfThisWeek<0"
                                    src="@imgPath/img/svg/icons/red-down-arrow.svg" alt=""
                                    class="sm-icon-dash">
                                    <div
                                    class="text-muted f-12px">{{chartValues.percentOfThisWeek}}</div></span> -->
                                    </h3>
                        </div>
                    </div>
                </div>
                <div class="ml-4">
                    <div class="wrap">
                        <div class="top"><span class="text-muted">{{$t('dashBoard.cSysWeeklySale.lastWeek')}} </span></div>
                        <div v-if="chartValues.lastWeekSum" class="bottom">
                            <h3 class="text-muted d-flex "> {{chartValues.currency+' '}}{{chartValues.lastWeekSum| formatNumber(chartValues.currency)}} 
                                <!-- <span
                                    class="d-flex pl-5px pb-3px"><img
                                    src="/img/red-down-arrow.20669387.svg" alt=""
                                    class="sm-icon-dash"><div
                                    class="text-muted f-12px">18.6</div></span> -->
                                    </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grap-wrap"> 
            <div class="sales ct-charts mt-5" v-if="chartValues.dataSets.length!=0">
                
                <CChartLineTwoSets :defaultDatasets="chartValues.dataSets" :chartLabels="chartValues.chartLabel" background-color="#137eff"/>



            </div>
        </div>
         <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert> 
    </div>

    


<!--    <CCard v-if="dataSets.length!=0">-->
<!--        <CCardBody>-->

<!--            <CChartLineTwoSets :defaultDatasets="dataSets" :chartLabels="chartLabel"/>-->
<!--        </CCardBody>-->
<!--    </CCard>-->


    <!-- <CCard >
<CCardBody>

      <CChartLineTwoSets />
    </CCardBody>
    </CCard> -->
</template>
<script>
    import Logger from "../../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../../router/index";
    import apiWeeklySales from "./../../../services/apiWeeklySales";
    import CChartLineTwoSets from "../../chart/CChartLineTwoSets"
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME, BOOKING_STATUS} from "../../../util/constants";
    import BaseConfiguration from "../../../config/base.js";
    import SERVICE_URL from "../../../config/API_DATA";
    import {mapGetters, mapActions} from "vuex";
    import {handleJWT, getErrorAlertValue} from "../../../util/util";
    var moment = require('moment');

    export default {
        name: COMPONENT_NAME.C_SYS_WEEKLY_SALES,

        data() {
            return {
                chartValues :{
                    dataSets: [],
                    chartLabel: [],
                    thisWeekSum : 0,
                    lastWeekSum:0,
                    currency:"",
                    
                } ,
                alertValue: null,               
            }
        },
        components: {
            CChartLineTwoSets
        },
        computed: {
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
        },
        async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                if (this.ADMIN_SIGNIN_RES) {
                    let weeklySalesRes = await this.getWeeklySales();
                    this.chartValues = this.toGetDataSets(weeklySalesRes)
                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_WEEKLY_SALES,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

        methods: {

            showAlert(val) {
                this.$emit("showAlert", val);
            },

            toGetDataSets(pWeeklySalesRes) {
                let retValue = {
                    dataSets: [],
                    chartLabel: [],
                    thisWeekSum : 0,
                    lastWeekSum:0,
                    currency:null,
                    //percentOfThisWeek:0
                };
                let dataSetsValue = [
                    {
                        label: this.$t('dashBoard.cSysWeeklySale.thisWeekLabel'),
                        //backgroundColor: 'rgb(228,102,81,0.9)',
                          backgroundColor: '#f6fcff',
                                borderColor: "#137eff",
                                pointBackgroundColor: "#137eff",//getColor(this.pointHoverColor),
          pointHoverBackgroundColor: "#137eff",//getColor(this.pointHoverColor),
                        data: []
                    },
                    {
                        label: this.$t('dashBoard.cSysWeeklySale.lastWeekLabel'),
                        //backgroundColor: 'rgb(0,216,255,0.9)',
                        backgroundColor: '#fafdff',
                                borderColor: "#c9d9ea",
                                pointBackgroundColor: "#c9d9ea",//getColor(this.pointHoverColor),
          pointHoverBackgroundColor: "#c9d9ea",//getColor(this.pointHoverColor),
                        data: []
                    }
                ];
                let dateValues = [];

                try {
                    let sumOfCurWeek = 0, sumOfLastWeek =0, currency=null;// percentOfCurWeek=0, salesDiff = 0;
                    if (BaseConfiguration.isDebug) console.log("toGetDataSets");
                    if (pWeeklySalesRes) {
                        if (pWeeklySalesRes.weeklySales.currentweek) {                            
                            for (let i = 0; i < pWeeklySalesRes.weeklySales.currentweek.length; i++) {
                                dateValues.push(this.$options.filters.formatDate(new Date(pWeeklySalesRes.weeklySales.currentweek[i].date), "ddd"));

                                dataSetsValue[0].data.push(pWeeklySalesRes.weeklySales.currentweek[i].amount);
                                sumOfCurWeek += pWeeklySalesRes.weeklySales.currentweek[i].amount;
                                if(!currency)
                                    currency = pWeeklySalesRes.weeklySales.currentweek[i].currency;
                            }
                        }                        
                        if (pWeeklySalesRes.weeklySales.pastweek) {
                            for (let i = 0; i < pWeeklySalesRes.weeklySales.pastweek.length; i++) {
                                dateValues.push(this.$options.filters.formatDate(new Date(pWeeklySalesRes.weeklySales.pastweek[i].date), "ddd"));
                                dataSetsValue[1].data.push(pWeeklySalesRes.weeklySales.pastweek[i].amount);
                                sumOfLastWeek+=pWeeklySalesRes.weeklySales.pastweek[i].amount;
                            }
                        }
                        /*salesDiff = (sumOfCurWeek/pWeeklySalesRes.weeklySales.currentweek.length)-(sumOfLastWeek/pWeeklySalesRes.weeklySales.pastweek.length);
                        percentOfCurWeek = salesDiff/((sumOfLastWeek/pWeeklySalesRes.weeklySales.pastweek.length)*100);*/
                    }
                    retValue.dataSets = dataSetsValue;
                    
                    retValue.chartLabel = [...new Set(dateValues)];
                    retValue.thisWeekSum = sumOfCurWeek;
                    retValue.lastWeekSum = sumOfLastWeek;
                    retValue.currency = currency;
                   /* if(percentOfCurWeek!=0) {
                    retValue.percentOfThisWeek=percentOfCurWeek.toFixed(2);
                    }*/
                    //this.chartLabel = [...new Set(dateValues)];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_WEEKLY_SALES,
                        "error in toGetDataSets",
                        err.toString(),
                        "toGetDataSets",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            async getWeeklySales() {
                if (BaseConfiguration.isDebug) console.log("getWeeklySales");
                let returnValue;
                try {
                    let weeklySalesReq = apiWeeklySales.buildRequest(); //constant

                    if (weeklySalesReq != null) {
                        let weeklySalesRes = await apiWeeklySales.getResponse(
                            weeklySalesReq
                        );
                        if (VALIDATE_SUCCESS_RES(weeklySalesRes)) {
                            returnValue = weeklySalesRes.data.data;

                        } else {
                            let error = getErrorMessage(weeklySalesRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_WEEKLY_SALES,
                        "error in  getWeeklySales",
                        err.toString(),
                        "getWeeklySales()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
        }
    }

</script>